<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div class="flex flex-wrap justify-between items-center">
        <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left"></div>
        <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
          <vs-button @click="refreshData" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
          <vs-button
            :to="{ name: 'master-location-add'} "
            class="btn mb-4 md:mb-0 mr-1"
            icon="add"
          >Add</vs-button>
          <vs-button
            :to="{ name: 'master-location-view', params: {id: selectedId} }"
            class="mb-4 md:mb-0 mr-1"
            icon="remove_red_eye"
            :disabled="selectedId ? false : true"
          >View</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="removeItem"
            icon="delete"
            :disabled="selectedId ? false : true"
          >Delete</vs-button>
          <vs-button class="mb-4 md:mb-0 mr-1" @click="showFilter = true" icon="filter_list">Filter</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            :to="{ name: 'master-location-sequence'}"
            icon="drag_indicator"
          >Sequence</vs-button>
          <vs-button
            class="mb-4 md:mb-0 mr-1"
            @click="labelPopup = true"
            icon="print"
            :disabled="selectedId ? false : true"
          >Print Label</vs-button>
          <vs-dropdown>
            <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
              <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
              <input type="file" ref="file" style="display: none" v-on:change="uploadExcel" />
              <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
      <ag-grid-vue
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="locations"
        colResizeDefault="shift"
        :animateRows="false"
        :floatingFilter="false"
        rowSelection="multiple"
        @selection-changed="onSelectionChanged"
        @rowDoubleClicked="viewData"
      ></ag-grid-vue>
      <p class="text-right">
        <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
      </p>
      <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

      <vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
        <div class="con-exemple-prompt">
          <!-- <vs-input placeholder="Location ID" v-model="filter.id" class="mt-4 mb-2 w-full" /> -->
          <vs-input
            placeholder="Location Code"
            v-model="filter.location_code"
            class="mb-2 w-full"
            label="Location Code"
          />
          <label class="vs-input--label">Location Type</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.location_type_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, location_type)"
          >
              <vs-select-item v-for="(item, index) in location_type.data" :key="index" :value="item.id" :text="item.code"/>
          </vs-select>
          <label class="vs-input--label">Dedicated Product</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.dedicated_product_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, product)"
          >
              <vs-select-item v-for="(item, index) in product.data" :key="index" :value="item.id" :text="item.product_code"/>
          </vs-select>
          <label class="vs-input--label">Client</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.client_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, client)"
          >
              <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
          </vs-select>
          <label class="vs-input--label">Section</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.section_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, section)"
          >
              <vs-select-item v-for="(item, index) in section.data" :key="index" :value="item.id" :text="item.section_code"/>
          </vs-select>
          <vs-input
            placeholder="Location Sequence"
            v-model="filter.location_squence"
            class="mb-2 w-full"
            label="Location Sequence"
          />
          <vs-input placeholder="Cap. Volume" v-model="filter.cap_volume" class="mb-2 w-full" label="Cap. Volume"/>
          <vs-input placeholder="Cap. Weight" v-model="filter.cap_weight" class="mb-2 w-full" label="Cap. Weight"/>
          <vs-input
            placeholder="Cap. Storage Unit"
            v-model="filter.cap_storage_unit"
            class="mb-2 w-full"
            label="Cap. Storage Unit"
          />
          <label class="vs-input--label">Warehouse</label>
          <vs-select
              class="selectExample mb-2"
              v-model="filter.warehouse_id"
              width="100%"
              autocomplete
              @input-change="searchDropdown($event, warehouse)"
          >
              <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
          </vs-select>
          <vs-checkbox
            placeholder="Pick Block"
            v-model="filter.pick_block"
            class="mb-2 w-full"
          >Pick Block</vs-checkbox>
          <vs-checkbox
            placeholder="Pick Block"
            v-model="filter.put_block"
            class="mb-2 w-full"
          >Put Block</vs-checkbox>
        </div>
      </vs-prompt>
    </vx-card>

    <vs-prompt @accept="printLabel" title="Label Type" :active.sync="labelPopup">
        <div class="con-exemple-prompt">
          <label class="vs-input--label">Label Type</label>
          <vs-select
              class="selectExample mb-2"
              v-model="labelType"
              width="100%"
          >
              <vs-select-item value="1" text="6 x 4 inch"/>
              <vs-select-item value="2" text="6 x 4 cm"/>
          </vs-select>
        </div>
      </vs-prompt>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { saveAs } from "file-saver";

export default {
  components: {
    vSelect,
    AgGridVue
  },
  data() {
    return {
      searchQuery: "",
      gridOptions: {},
      maxPageNumbers: 7,
      gridApi: null,
      locations: [],
      labelPopup: false,
      labelType: 1,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        editable: false,
        resizable: true,
        suppressMenu: true
      },
      selectedId: null,
      isLoading: false,
      maxRetry: 10,
      showFilter: false,
      filter: {
        id: "",
        location_code: "",
        location_type_id: null,
        client_id: null,
        section_id: null,
        dedicated_product_id: null,
        location_squence: "",
        cap_volume: "",
        cap_weight: "",
        cap_storage_unit: "",
        warehouse_id: null,
        pick_block: "",
        put_block: ""
        // clienttype_id: null
      },
      locationtypes: [],
      dedicatedProduct: [],
      clients: [],
      sections: [],
      warehouses: [],

      // Pagination
      totalPage: 0,
      currentPage: 1,
      dataFrom: 0,
      dataTo: 0,
      dataTotal: 0,
      location_type: {
        data: [],
        loading: false,
        endpoint: 'master/locationtypes',
        objectKey: 'code'
      },
      product: {
        data: [],
        loading: false,
        endpoint: 'master/product',
        objectKey: 'product_code'
      },
      client: {
        data: [],
        loading: false,
        endpoint: 'master/clients',
        objectKey: 'client_code'
      },
      section: {
        data: [],
        loading: false,
        endpoint: 'master/sections',
        objectKey: 'section_code'
      },
      warehouse: {
        data: [],
        loading: false,
        endpoint: 'master/warehouses',
        objectKey: 'warehouses_code'
      },
    };
  },
  watch: {
    "$store.state.windowWidth"(val) {
      if (val <= 576) {
        this.maxPageNumbers = 4;
        this.gridOptions.columnApi.setColumnPinned("email", null);
      } else this.gridOptions.columnApi.setColumnPinned("email", "left");
    },

    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    },
    currentPage: function() {
      this.fetchData();
    }
  },
  methods: {
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      var selectedRowsString = "";
      selectedRows.forEach(function(selectedRow, index) {
        if (index !== 0) {
          selectedRowsString += ", ";
        }
        selectedRowsString += selectedRow.id;
      });
      this.selectedId = selectedRowsString;
    },
    removeItem() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this Location?",
        accept: this.acceptAlert
      });
    },
    acceptAlert() {
      this.isLoading = true;
      this.$http
        .delete("master/locations/" + this.selectedId + "/destroy")
        .then(res => {
          this.$vs.notify({
            color: "success",
            title: "Location deleted",
            iconPack: "feather",
            icon: "icon-check",
            text: "The selected Location was successfully deleted"
          });
        })
        .catch(error => {
          this.$vs.notify({
            title: "Error",
            text: "Error.",
            color: "danger"
          });
        })
        .then(() => {
          this.fetchData();
        });
    },
    refreshData() {
      this.fetchData();
    },
    fetchData() {
      this.isLoading = true;
      this.maxRetry = this.maxRetry - 1;
      this.$http.post("master/locations?page=" + this.currentPage, this.filter, {
            onDownloadProgress: function(progressEvent) {
            console.log('download', progressEvent);
        }
        })
        .then(resp => {
          this.locations = resp.data.data;
          this.totalPage = resp.data.last_page;
          this.currentPage = this.currentPage;
          this.dataTotal = resp.data.total;
          this.dataFrom = resp.data.from;
          this.dataTo = resp.data.to;
          this.isLoading = false;
        })
        .catch(resp => {
          if (this.maxRetry == 0) {
            this.isLoading = false;
            this.$vs.dialog({
              type: "confirm",
              color: "danger",
              title: "Server Error",
              text: "Try again?",
              accept: () => {
                this.refreshData();
              },
              acceptText: "Yes",
              cancelText: "No"
            });
            return;
          }
          this.fetchData();
        });
    },
    viewData() {
      this.$router.push({
        name: "master-location-view",
        params: {
          id: this.selectedId
        }
      });
    },
    filterData() {
      this.currentPage = 1;
      this.showFilter = false;
      if (this.filter.put_block) {
        this.filter.put_block = 1;
      } else {
        this.filter.put_block = 0;
      }
      if (this.filter.pick_block) {
        this.filter.pick_block = 1;
      } else {
        this.filter.pick_block = 0;
      }
      this.fetchData();
    },
    filterActive() {
      this.showFilter = true;
      Promise.all([
        this.$http.post("master/locationtypes/filter/dropdown"),
        this.$http.post("master/clients/filter/dropdown"),
        this.$http.post("master/sections/filter/dropdown"),
        this.$http.post("master/warehouses/filter/dropdown"),
        this.$http.post("master/product/filter/dropdown")
      ])
        .then(
          this.$http.spread((locationtypes, clients, sections, warehouses, product) => {
            this.locationtypes = locationtypes.data;
            this.dedicatedProduct = product.data;
            this.clients = clients.data;
            this.sections = sections.data;
            this.warehouses = warehouses.data;
            this.isLoading = false;
          })
        )
        .catch(resp => {
          if (this.maxRetry == 0) {
            this.isLoading = false;
            this.$vs.dialog({
              type: "confirm",
              color: "danger",
              title: "Server Error",
              text: "Try again?",
              accept: () => {
                this.refreshData();
              },
              acceptText: "Yes",
              cancelText: "No"
            });
            return;
          }
          this.fetchData();
        });
    },
    getTemplate() {
      this.isLoading = true;
      this.$http
        .get("master/locations/report/gettemplate", {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "Locations-template.xlsx");
        });
    },
    uploadExcel(e) {
      let file = e.target.files[0];
      let form = new FormData();
      form.append("file", file);
      this.isLoading = true;
      this.$http
        .post("/master/locations/report/importexcel", form, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(resp => {
          this.isLoading = false;
          this.fetchData();
          this.$vs.notify({
            color: "success",
            title: "Upload Success",
            text: "Upload success."
          });
        })
        .catch(error => {
          this.isLoading = false;
          const message = error.response.data.message
            ? error.response.data.message
            : "Something went wrong";
          this.$vs.notify({
            color: "danger",
            title: "Upload Failed",
            text: message
          });
        });
    },
    exportExcel() {
      this.isLoading = true;
      this.$http
        .post("master/locations/report/exportexcel", this.filter, {
          responseType: "blob"
        })
        .then(response => {
          this.isLoading = false;
          saveAs(response.data, "Locations-list-export.xlsx");
        });
    },
    fetchDropdown() {
      this.isLoading = true
      return Promise.all([
          this.$http.post("master/locationtypes"),
          this.$http.post("master/product"),
          this.$http.post("master/clients"),
          this.$http.post("master/sections"),
          this.$http.post("master/warehouses"),
      ]).then(this.$http.spread((locationtypes, products, clients, sections, warehouses) => {
        locationtypes.data.data.map(location_type => {
            if(this.location_type.data.findIndex(a => a.id == location_type.id) === -1) {
                this.location_type.data.push(location_type)
            }
        })

        products.data.data.map(product => {
            if(this.product.data.findIndex(a => a.id == product.id) === -1) {
                this.product.data.push(product)
            }
        })

        clients.data.data.map(client => {
            if(this.client.data.findIndex(a => a.id == client.id) === -1) {
                this.client.data.push(client)
            }
        })

        sections.data.data.map(section => {
            if(this.section.data.findIndex(a => a.id == section.id) === -1) {
                this.section.data.push(section)
            }
        })

        warehouses.data.data.map(warehouse => {
            if(this.warehouse.data.findIndex(a => a.id == warehouse.id) === -1) {
                this.warehouse.data.push(warehouse)
            }
        })
      }))
    },
    printLabel() {
        const ids = this.gridApi.getSelectedRows().map(i => i.id)
        this.isLoading = true
        
        this.$http.post('master/locations/printlabel', {ids: ids, type: this.labelType}, {responseType: 'blob'})
        .then(response => {
            var blob = new Blob([response.data], {
                type: 'application/pdf'
            })
            window.open(URL.createObjectURL(blob))
        })
        .then(() => this.isLoading = false)
    }
  },
  mounted() {
    this.fetchDropdown().then(() => this.fetchData())
    this.gridApi = this.gridOptions.api;
  },
  beforeMount() {
    this.columnDefs = [
      // {
      //   headerName: "Location ID",
      //   field: "id",
      //   width: 140,
      // },
      {
        headerName: "Location Code",
        field: "location_code",
        width: 170,
        checkboxSelection: true,
        headerCheckboxSelection: true,
      },
      {
        headerName: "Location Type",
        field: "name",
        width: 120
      },
      {
        headerName: "Client",
        field: "client_code",
        width: 120
      },
      {
        headerName: "Dedicated Product",
        field: "product_code",
        width: 120
      },
      {
        headerName: "Section",
        field: "section_code",
        width: 120
      },
      {
        headerName: "Location Sequence",
        field: "location_squence",
        width: 120
      },
      {
        headerName: "Cap Volume",
        field: "cap_volume",
        width: 120
      },
      {
        headerName: "Cap Weight",
        field: "cap_weight",
        width: 120
      },
      {
        headerName: "Cap Storage Unit",
        field: "cap_storage_unit",
        width: 120
      },
      {
        headerName: "Warehouse",
        field: "warehouses_code",
        width: 120
      }
    ];

    this.gridOptions.getRowHeight = function(params) {
        return 35;
    }
  }
};
</script>